import { For, Show } from 'solid-js'
import { pendingPrefix, SHORTCUTS } from '../store/shortcuts.ts'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/Dialog.tsx'

const GROUPS = [
  ['global', 'anywhere'],
  ['search', 'search results'],
  ['file', 'file view'],
] as const

export function ShortcutsDialog(props: { open: boolean, onOpenChange: (open: boolean) => void }) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent class="max-w-lg">
        <DialogHeader>
          <DialogTitle>keyboard shortcuts</DialogTitle>
        </DialogHeader>

        <div class="flex flex-col gap-4">
          <For each={GROUPS}>
            {([group, title]) => (
              <div>
                <div class="mb-1 text-xs text-muted-foreground">{title}</div>
                <For each={SHORTCUTS.filter(it => it.group === group)}>
                  {shortcut => (
                    <div class="flex items-center gap-3 py-0.5 text-sm">
                      <kbd class="min-w-24 shrink-0 border border-border rounded bg-muted px-1.5 py-0.5 text-center text-xs font-mono">
                        {shortcut.keys}
                      </kbd>
                      <span class="text-muted-foreground">{shortcut.description}</span>
                    </div>
                  )}
                </For>
              </div>
            )}
          </For>
        </div>
      </DialogContent>
    </Dialog>
  )
}

/** the "you pressed l, now press the second key" hint, bottom right like code search */
export function PendingPrefix() {
  return (
    <Show when={pendingPrefix()}>
      {prefix => (
        <div class="fixed bottom-3 right-3 z-50 border border-border rounded bg-card px-2 py-1 text-xs text-muted-foreground shadow-md">
          <span class="text-foreground font-mono">{prefix()}</span>
          {' then...'}
        </div>
      )}
    </Show>
  )
}
